<!--https://medium.com/@claudiaconceic/infinite-plain-javascript-slider-click-and-touch-events-540c8bd174f2-->
<!--https://codepen.io/cconceicao/pen/PBQawy-->
<template>
    <div id="slider" class="slider" >
        <div id="wrapper" class="wrapper">
            <!--agora vai: {{ bannersIm }}-->
            <div id="slides" class="slides">
                <div v-for="(item, i) in bannersImSmall" :key="i" class="slide">
                    <img :src="baseUrlImg + item.file" class="slideItem"/>
                </div>
            </div>
        </div>
        <a id="prev" class="control prev" @click="shiftSlide(-1)"></a>
        <a id="next" class="control next" @click="shiftSlide( 1)"></a>
    </div>
</template>

<script>
    export default {
        props: {
            baseUrlImg: {
                type: String,
                default: ''
            },
            banners: {
                type: Array | Boolean
            },
            fotoIndex: {
                type: Number
            },
            showB: {
                type: Boolean
            }
        },
        watch: {
            showB (newValue, oldValue) {
                console.log('show::newValue: ', newValue)

                this.initFields()

                console.log('watch::show::vou scrolar para o offset 1', this.increStep)
                if (this.divSlides1 != null)
                    this.divSlides1.scrollLeft(this.increStep);
            },
            banners (newValue, oldValue) {
                console.log('banners::newValue: ', newValue)
                console.log('banners::oldValue: ', oldValue)
                var vm = this

                // if (typeof newValue == Array) {
                console.log('atualizando bannersIm');
                this.bannersIm = newValue
                for (let i = 0; i < this.bannersIm.length; i++) {
                    console.log('img: ' + i + ': ', this.bannersIm[i].file)

                    // Adiciona as 3 primeiras imagens ao vetor Small
                    if (i < 3 && this.bannersImSmall.length < 3) {
                        var el = {
                            file: this.bannersIm[i]
                        }
                        this.bannersImSmall.push(el)
                    }
                }
                this.indexChange(this.index);

                this.initFields()
                // }
            },
            fotoIndex (newValue, oldValue) {
                console.log('alterando index para: ', newValue)
                this.index = newValue;
                this.indexChange(newValue);
                // this.divSlides1.scrollLeft(this.increStep); // volta para o slider do meio
            }
        },

        data () {
            return {
                scrolling: false,
                lastScroll: 0,
                shiftingSlide: false,

                divSlides1: null,
                divSlides2: null,
                maxWidth: 0,
                increStep: 0,
                index: 0,
                index_new: 0,

                offsetLeft: 0,
                bannersImSmall: [],
                bannersIm: []
            }
        },
        methods: {
            changeFatherIndex () {
                this.$emit('emit-index', this.index)
            },
            initFields() {
                var vm = this
                vm.$nextTick(function () {
                    setTimeout(function () {
                        if (vm.divSlides2 == null) {

                            var divname = 'slides'
                            vm.divSlides1 = $('#' + divname);
                            vm.divSlides2 = document.getElementById(divname)
                            // vm.maxWidth = vm.divSlides2.scrollWidth;
                            // vm.increStep = vm.divSlides2.clientWidth * (1.0 / 1.0);
                            // console.log('maxWidth: ', vm.maxWidth, vm.increStep)
                            vm.divSlides2.addEventListener('scroll', vm.myHandleScroll, false);
                        }

                        if ((vm.maxWidth == 0 || vm.increStep == 0)) {
                            console.log('initFields::vou scrolar para o offset 1')
                            vm.maxWidth = vm.divSlides2.scrollWidth;
                            vm.increStep = vm.divSlides2.clientWidth * (1.0 / 1.0);
                            if (vm.maxWidth == 0) {
                                vm.increStep = $(document).width();
                                vm.maxWidth = vm.increStep * vm.bannersImSmall.length;
                            }
                            vm.offsetLeft = vm.increStep;
                            vm.divSlides1.scrollLeft(vm.offsetLeft);
                        }
                    }, 100);
                });
            },
            indexChange(index) {
                console.log('index: ', index)

                if (this.bannersImSmall.length > 0)
                    this.bannersImSmall[0].file = this.bannersIm[(index - 1) < 0 ? this.bannersIm.length - 1 : index - 1].file;
                if (this.bannersImSmall.length > 1)
                    this.bannersImSmall[1].file = this.bannersIm[index].file;
                if (this.bannersImSmall.length > 2)
                    this.bannersImSmall[2].file = this.bannersIm[(index + 1) % this.bannersIm.length].file;
            },
            shiftSlide (dir) {
                console.log('shiftSlide: ', dir)

                if (this.maxWidth == 0 || this.increStep == 0) {
                    this.maxWidth = this.divSlides2.scrollWidth;
                    this.increStep = this.divSlides2.clientWidth * (1.0 / 1.0);
                    console.log('maxWidth: ', this.maxWidth, this.increStep)
                }

                // console.log('1scrollEstabs:el.scrollLeft ', this.divSlides1.scrollLeft());

                if (dir > 0) {
                    this.index = (this.index + 1) % this.bannersIm.length;
                    this.indexChange(this.index);
                    this.changeFatherIndex();
                } else if (dir < 0) {
                    this.index--;
                    if (this.index < 0) {
                        this.index = this.bannersIm.length - 1;
                    }
                    this.indexChange(this.index);
                    this.changeFatherIndex();
                }
                else {
                    return
                }
                this.divSlides1.scrollLeft(this.offsetLeft);
            },
            myHandleScroll () {
                // console.log('myHandleScroll 1: ');
                var vm = this
                vm.scrolling = true
                vm.lastScroll = Date.now()

                // console.log('myHandleScroll:scrollLeft ', this.divSlides1.scrollLeft());
                // console.log('myHandleScroll:offsetLeft ', this.offsetLeft);

                if (vm.divSlides1.scrollLeft() >= vm.increStep * 2) {
                    console.log('tentar parar direita...', vm.divSlides1.scrollLeft(), vm.offsetLeft, vm.increStep)
                    vm.index = (vm.index + 1) % vm.bannersIm.length;
                    vm.indexChange(vm.index);
                    vm.divSlides1.scrollLeft(vm.increStep); // volta para o slider do meio
                    vm.changeFatherIndex();
                }
                else if (vm.divSlides1.scrollLeft() <= 0) {
                    console.log('tentar parar esquerda...', vm.divSlides1.scrollLeft(), vm.offsetLeft, vm.increStep)
                    // vm.divSlides1.scrollLeft(0);
                    vm.index--;
                    if (vm.index < 0) {
                        vm.index = vm.bannersIm.length - 1;
                    }
                    vm.indexChange(vm.index);
                    vm.divSlides1.scrollLeft(vm.increStep); // volta para o slider do meio
                    vm.changeFatherIndex();
                }
                else {
                    // console.log('entrei no else', vm.scrolling, this.divSlides1.scrollLeft(), this.offsetLeft)
                    if (vm.scrolling && !vm.shiftingSlide && this.divSlides1.scrollLeft() != this.offsetLeft) {
                        vm.$nextTick(function () {
                            setTimeout(function () {
                                // console.log('entrei no else 2')
                                if ((Date.now() - vm.lastScroll > 50) && vm.scrolling && !vm.shiftingSlide) {
                                    // console.log('parei')
                                    vm.scrolling = false
                                    vm.shiftingSlide = true
                                    vm.$nextTick(function () {
                                        let myScroll
                                        if (vm.divSlides1.scrollLeft() > (vm.increStep * 1.5)) {
                                            myScroll = vm.increStep * 2
                                        } else if (vm.divSlides1.scrollLeft() < vm.increStep * 0.5) {
                                            myScroll = 0
                                        }
                                        else {
                                            myScroll = vm.increStep
                                        }
                                        vm.divSlides1.animate({'scrollLeft': myScroll},
                                            {
                                                easing: 'swing',
                                                duration: 300,
                                                complete: function () {
                                                    // if (vm.divSlides2 != null)
                                                    //     vm.divSlides2.addEventListener('scroll', vm.myHandleScroll, false);
                                                    vm.lastScroll = Date.now()
                                                    vm.shiftingSlide = false
                                                    // console.log('completei ')
                                                }
                                            })
                                    })
                                    // console.log('passei')
                                }
                            }, 70)
                        })
                    }
                }
            },
            restartSlider (rot) {
                console.log('restartSlider: rot: ', rot)
                var vm = this
                vm.maxWidth = 0;
                vm.increStep = 0;
                vm.initFields();
                vm.shiftSlide(1);
            }
        },
        mounted () {
            console.log('Slider::mounted')

            // window.addEventListener('scroll', this.myHandleScroll)
            if (this.divSlides1 != undefined) {
                // console.log('Slider:mounted::', this.offsetLeft)
                this.divSlides1.scrollLeft(this.increStep);
            }

            // window.addEventListener("orientationchange", this.restartSlider, false);
        },
        beforeDestroy () {
            // window.removeEventListener('orientationchange', this.restartSlider)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    * {
        /*box-sizing: border-box;*/
        /*--slider-width: 100vw;*/
        --slider-width: 100vw;
        --slider-height: 50vh;
    }

    body {
        height: 100%;
        background-color: #7656d6;
        color: #333;
        text-align: center;
        letter-spacing: 0.15em;
        font-size: 22px;
    }

    .slider {
        position: relative;
        width: var(--slider-width);
        height: var(--slider-height);
        /*box-shadow: 3px 3px 10px rgba(0,0,0,.2);*/
        /*background-color: pink;*/
    }

    .wrapper {
        position: relative;
        /*overflow: hidden;*/
        width: var(--slider-width);
        height: var(--slider-height);
        /*z-index: 1;*/
    }

    .slides {
        display: flex;
        position: relative;
        top: 0;
        overflow-x: scroll;
    }
    /*Hide Scrollbar indicator*/
    .slides {
        scrollbar-width: none;
        -ms-overflow-style: none;
    }
    .slides::-webkit-scrollbar {
        width: 0px; /* For Chrome, Safari, and Opera */
        display: none;
    }

    .slides.shifting {
        transition: left .5s linear;
    }

    .slide {
        width: var(--slider-width);
        height: var(--slider-height);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        transition: all 1s;
        position: relative;
        /*background: #FFCF47;*/
        /*background-color: white;*/
        /*background-color: purple;*/
        border-radius: 2px;
    }

    .slideItem {
        width: 100vw;
        height: 100%;
        object-fit: contain;
        /*background-color: red;*/
    }

    .control {
        position: absolute;
        top: 50%;
        width: 50px;
        height: 50px;
        /*background: #fff;*/
        border-radius: 50px;
        margin-top: -20px;
        /*box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);*/
        /*z-index: 2;*/
    }

    .prev,
    .next {
        background-size: 15vw;
        background-position: center;
        background-repeat: no-repeat;
        /*background-color: red;*/
        cursor: pointer;
    }

    .prev {
        /*background-image: url('/static/imgs/ic_right-128.png');*/
        background-image: url('/static/imgs/ic_left_2.png');

        /*left: -20px;*/
    }

    .next {
        /*background-image: url('/static/imgs/ic_left-128.png');*/
        background-image: url('/static/imgs/ic_right_2.png');
        /*right: -20px;*/
    }

    .prev:active,
    .next:active {
        transform: scale(.8);
    }

    @media screen and (max-width: 999px) {
        * {
            --slider-width: 100vw;
            --slider-height: 40vh;
        }
        .next, .prev {
            background-size: 8vw;
        }
        .prev {
            left: -2%;
        }
        .next {
            right: -2%;
        }
        .control {
            width: 15vw;
            height: 15vw;
        }
    }
    @media screen and (min-width: 1000px) {
        * {
            --slider-width: 90vw;
        }
    }
    @media screen and (min-width: 1400px) {
        * {
            --slider-width: 80vw;
        }
    }
    @media screen and (min-width: 1600px) {
        * {
            --slider-width: 70vw;
        }
    }
    @media screen and (min-width: 1900px) {
        * {
            --slider-width: 65vw;
        }
    }
    @media screen and (min-width: 2200px) {
        * {
            --slider-width: 50vw;
        }
    }
    @media screen and (orientation:landscape) {
        * {
            --slider-width: 100vw;
            --slider-height: 100vh;
        }

        .slideItem {
            object-fit: contain;
        }

        .control {
            width: 10vw;
            height: 10vw;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/templates/Slider.vue